import { render, staticRenderFns } from "./RecoverPasswordModal.vue?vue&type=template&id=b6b5be94&scoped=true&"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5be94",
  null
  
)

export default component.exports